import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AppConfigService } from '../app-config.service';

@Injectable()
export class ApiPrefixInterceptorService implements HttpInterceptor
{
    constructor(private appConfigService: AppConfigService) { }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        const config = this.appConfigService.getConfig();
        const baseApiUrl = config.api.baseUrl;
        const isAbsoluteURLRegex = /^(?:\w+:)\/\//;

        // If not absolute URL (REST API), add base url automatically
        let urlPrefix = '';
        if (!isAbsoluteURLRegex.test(request.url) && request.url.substring(0, 1) === '/' && !request.url.includes('index.html'))
        {
            urlPrefix = baseApiUrl;
        }

        // Clone request to set url
        const apiRequest = request.clone({ url: `${urlPrefix}${request.url}` }); 
        return next.handle(apiRequest);
    }
}

